import React, { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Stack } from '@mui/material';
import { Icons } from 'src/components/icons';

interface OrganizationsTableActionsProps {
  item: Record<string, any>;
  onEdit: (id: string | number) => void;
  onDelete: (id: string | number) => void;
}

export const LocationsTableActions: ComponentType<OrganizationsTableActionsProps> = ({
  item,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row">
      <>
        <IconButton
          onClick={() => onEdit(item.id)}
          color="info"
          aria-label={t('action.edit', 'Редактировать')}
          size="small"
        >
          <Icons.Pencil />
        </IconButton>

        <IconButton
          onClick={() => onDelete(item.id)}
          color="error"
          aria-label={t('action.delete', 'Удалить')}
          size="small"
        >
          <Icons.Close />
        </IconButton>
      </>
    </Stack>
  );
};
